import React, { Component } from "react";
// import Header from "./Components/Common/Header";
import { Route, Switch } from "react-router-dom";


// import "./App.css";//I should import this before the other pages, otherwise their CSS will be overriden by App.css
import HomePage from "./Components/Home/HomePage";
import LandingPage from "./Components/LandingPage/LandingPage";
import SuccessPage from "./Components/SuccessPage/SuccessPage";
// import AboutPage from "./Components/About/AboutPage";
// import PortfolioPage from './Components/Portfolio/PortfolioPage';
// import ProjectsPage from './Components/Projects/ProjectsPage';
// import EquipmentPage from './Components/Projects/EquipmentPage';
// import KubernetesDemoPage from './Components/Portfolio/SubPage/KubernetesDemoPage';
// import ContainerAppsDemoPage from './Components/Portfolio/SubPage/ContainerAppsDemoPage';
// import FGRSecureAPIDemoPage from './Components/Portfolio/SubPage/FGRSecureAPIDemoPage';
// import BilliardReplayDemoPage from './Components/Portfolio/SubPage/BilliardReplayDemoPage';
// import CustomVisionDemoPage from './Components/Portfolio/SubPage/CustomVisionDemoPage';
// import APIManagementDemoPage from './Components/Portfolio/SubPage/APIManagementDemoPage';
import NotFound from "./Components/Common/NotFound";
// import PrivacyPolicy from "./Components/Common/PrivacyPolicy";
// import DeviceRecommendations from "./Components/Common/DeviceRecommendations";
// import Tools from "./Components/Common/Tools";
import ElementsOptIn from "./Components/Common/115Elements";
import { Helmet } from "react-helmet";



class App extends Component {
  render() {
    return (<>

      <Helmet>
        <script>
          {`
    (function (w, d, e, u, f, l, n) {
      w[f] = w[f] || function () {
        (w[f].q = w[f].q || [])
        .push(arguments);
      }, l = d.createElement(e), l.async = 1, l.src = u,
      n = d.getElementsByTagName(e)[0], n.parentNode.insertBefore(l, n);
    })
      (window, document, 'script', 'https://assets.mailerlite.com/js/universal.js', 'ml');
    ml('account', '849879');
    `}
        </script>
      </Helmet>


      <div className="fullpage">

        <div className=" container">
          {/* <Header /> */}
        </div>

        <Switch>
          <Route exact path="/" component={LandingPage} />
          {/* <Route exact path="/" component={HomePage} /> */}
          <Route exact path="/success" component={SuccessPage} />
          {/* <Route exact path="/about" component={AboutPage} />
          <Route exact path="/projects" component={ProjectsPage} />
          <Route exact path="/projects/equipment" component={EquipmentPage} />
          <Route exact path="/portfolio" component={PortfolioPage} />
          <Route exact path="/portfolio/kubernetes-demo" component={KubernetesDemoPage} />
          <Route exact path="/portfolio/azure-container-apps-deployment" component={ContainerAppsDemoPage} />
          <Route exact path="/portfolio/billiard-replay" component={BilliardReplayDemoPage} />
          <Route exact path="/portfolio/custom-vision" component={CustomVisionDemoPage} />
          <Route exact path="/portfolio/api-managment" component={APIManagementDemoPage} />
          <Route exact path="/portfolio/fgr-secure-api" component={FGRSecureAPIDemoPage} />


          <Route exact path="/privacypolicy" component={PrivacyPolicy} />
          <Route exact path="/devicerecommendations" component={DeviceRecommendations} />
          <Route exact path="/tools" component={Tools} /> */}

          {/* <Route exact path="/115Elements" component={ElementsOptIn} /> */}

          <Route component={NotFound} />
        </Switch>




      </div>
    </>




    );
  }
}

export default App;
